import { Clock, Elevator, ShieldCheck, Sparkle } from "@phosphor-icons/react";

const items = [
  { id: "service-hours", icon: Clock, title: "7/24 Planlama", text: "Yoğun dönemlerde hızlı dönüş" },
  { id: "elevator", icon: Elevator, title: "Asansörlü Taşıma", text: "Yüksek katlarda güvenli çözüm" },
  { id: "insured", icon: ShieldCheck, title: "Sigortalı Nakliyat", text: "Eşyalarınız kontrollü taşınır" },
  { id: "expertise", icon: Sparkle, title: "Ücretsiz Ekspertiz", text: "Net plan, net fiyat yaklaşımı" },
];

export default function TrustBar() {
  return (
    <section id="guvence" data-testid="trust-section" className="border-y border-white/10 bg-[#121214]">
      <div data-stagger-group="trust-cards" className="mx-auto grid max-w-7xl grid-cols-1 gap-px px-6 py-8 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.id} data-stagger-item="trust-card" data-testid={`trust-card-${item.id}`} className="group rounded-xl p-5 transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-white/[0.03]">
              <Icon data-testid={`trust-icon-${item.id}`} size={32} weight="duotone" className="mb-4 text-orange-500" />
              <h3 data-testid={`trust-title-${item.id}`} className="font-heading text-lg font-black text-white">{item.title}</h3>
              <p data-testid={`trust-text-${item.id}`} className="mt-2 text-sm text-slate-400">{item.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}